<template>
  <button
    type="button"
    class="ca-slider-chip"
    :class="{ 'ca-slider-chip--active': active }"
    :disabled="disabled"
    role="tab"
    :aria-selected="active"
    :tabindex="active ? 0 : -1"
    @click="$emit('click')"
  >
    {{ label }}
  </button>
</template>

<script setup>
defineOptions({
  name: "CaSliderChip",
});

defineProps({
  label: {
    type: String,
    default: "",
  },
  active: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["click"]);
</script>

<style scoped lang="scss">
.ca-slider-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--size-3);
  padding: var(--size-3) var(--size-5);
  border-radius: var(--size-5);
  border: none;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--ca-color-text-inverted);
  font-family: var(--font-family-paragraph);
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.216px;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  &:focus-visible {
    outline: 2px solid var(--ca-color-feedback-info);
    outline-offset: 2px;
  }

  &--active {
    background-color: var(--ca-color-neutrals-inverted);
    color: var(--ca-color-text-primary);

    &:hover {
      background-color: var(--ca-color-neutrals-inverted);
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
}
</style>
